var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{ 'no-header': _vm.noHeader },attrs:{"id":"home"}},[(_vm.showMobileHeader)?_c('h5-header'):(!_vm.noHeader)?_c('headerComponent'):_vm._e(),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }